export default {
    edit_alert_type_supported_title: "Editar tipo de alerta Modelo de dispositivo",
    edit_alert_type_supported_success_message: "Se ha editado el modelo de dispositivo",
    edit_alert_type_supported_error_message: "El modelo del dispositivo no ha sido editado",
    edit_alert_type_supported_contract_all: "Contraer Todos",
    edit_alert_type_supported_expand_all: "Expandir todo",
}